import { render, staticRenderFns } from "./SelectProductTransfer.vue?vue&type=template&id=b1041c44&"
import script from "./SelectProductTransfer.vue?vue&type=script&lang=js&"
export * from "./SelectProductTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports